export default __webpack_public_path__ + "login_footer_2.7c8daa.svg";